export interface FileDetail {
  columnName: string;
  datatype: string;
  required: boolean;
}

export type AvailableFileCategories = Record<string, FileDetail[]>;

export enum FileReqColumnFields {
  COLUMN_NAME = 'columnName',
  DATA_TYPE = 'datatype',
  REQUIRED = 'required',
}

export enum FileReqColumnHeaderNames {
  COLUMN_NAME = 'Column Name',
  DATA_TYPE = 'Data Type',
  REQUIRED = 'Required',
}

export const WRITE_OFFS_CATEGORY = 'writeOffs';

export const ACCOUNTING_BILLED_VOID_CLAIMS_CATEGORY =
  'accountingBilledVoidClaims';
